module.exports = __webpack_public_path__ + "media/images/front/bg_doctor_header-de8e393a20cb8449d289d910c03b8d79.jpg";